import { render, staticRenderFns } from "./content.vue?vue&type=template&id=64ee76d7&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"
import style0 from "./content.vue?vue&type=style&index=0&id=64ee76d7&prod&scoped=true&lang=css"
import style1 from "./content.vue?vue&type=style&index=1&id=64ee76d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ee76d7",
  null
  
)

export default component.exports